import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The detail route holds no page of its own — it forwards to the first tab, the
 * way `/management` forwards to its default tool.
 */
export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/',
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/management/companies/$companyId/general-info',
      params: { companyId: params.companyId },
      search,
    });
  },
});
